<template>
  <div class="login-page page-padding-top">

    <div class="title" v-show="step == 1">{{ $t('resetPassword.title1') }}</div>
    <div class="title" v-show="step == 2 ">{{ $t('register.auth1') }}</div>
    <div class="title" v-show="step == 3 ">{{ $t('resetPassword.title') }}</div>

    <div class="tabs flex" v-show="step == 1">
      <div class="tab flex-center" :class="tabIndex == 1 ? 'active' : ''" @click="changeTab(1)">{{ $t('shou-ji-deng-lu') }}</div>
      <div class="tab flex-center" :class="tabIndex == 2 ? 'active' : ''" @click="changeTab(2)">{{ $t('you-xiang-deng-lu') }}</div>
    </div>

    <div class="login-form">

      <div class="form-label" v-if="tabIndex == 2 && step == 1">{{ $t('you-xiang-hao-ma') }}</div>
      <div class="form-item  flex-center" v-if="tabIndex == 2 && step == 1">
        <div class="input"> 
          <input type="text" v-model="form.username" :placeholder="$t('qing-shu-ru-you-xiang-hao-ma-1')">
        </div>
      </div>

      <div class="form-label" v-if="tabIndex == 1 && step == 1">{{ $t('shou-ji-hao-ma') }}</div>
      <div class="form-item  flex-center " :class="inputActive ? 'active' : ''" v-if="tabIndex == 1 && step == 1">
        <a-select v-model="phonePre" option-label-prop="label" dropdownClassName="country-select" class="hide-border">
          <img :src="downUrl" slot="suffixIcon" class="suffix-icon">
          <a-select-opt-group  v-for="(item, i) in countryList" :key="i">
            <span slot="label">{{item.title}}</span>
            <a-select-option v-for="(child, index) in item.children" :key="index" :value="child.key" :label="child.key">
              {{child.title}}
            </a-select-option>
          </a-select-opt-group>
        </a-select>
        <div class="flex-1">
          <div class="input clear"> 
            <input type="tel" v-model="form.phone" @focus="inputActive = true" @blur="inputActive = false" :placeholder="$t('qing-shu-ru-shou-ji-hao-ma-1')">
          </div>
        </div>
      </div>  

      <div class="form-label" v-if="step == 2">{{ $t('yan-zheng-fang-shi') }}</div>
      <div class="form-item  flex-center" v-if="step == 2">
        <div class="input"> 
          <input type="text" v-model="form.username" :placeholder="$t('qing-shu-ru-you-xiang-hao-ma-2')">
        </div>
      </div>

      <div class="form-label" v-if="step == 2 && tabIndex == 2">
        {{ $t('register.label6_2') }} <span v-show="isDisabled">{{ $t('yi-fa-song-zhi-thisformusername', [this.form.username]) }}</span>
      </div>
      <div class="form-label" v-if="step == 2 && tabIndex == 1">
        {{ $t('duan-xin-yan-zheng-ma') }} <span v-show="isDisabled">{{ $t('yi-fa-song-zhi-thisformphone', [this.form.phone]) }}</span>
      </div>
      <div class="form-item clear flex-center" v-show="step == 2" >
        <div class="input long"> 
          <input type="tel"  v-model="form.code"  :placeholder="$t('qing-shu-ru-yan-zheng-ma-0')">
        </div>
        <div class="adot long">
          <span class="gray" v-if="isDisabled">{{ $t('timecount-hou-zhong-xin-fa-song', [timeCount]) }}</span>
          <span class="blue" v-else @click="resend">{{ $t('resetPassword.btn1') }}</span>
        </div>
      </div>


      <div class="form-label" v-show="step == 3">
        {{ $t('resetPassword.label1') }} </div>

      <div class="form-item flex-center" v-if="step == 3" >
        <div class="input"> 
          <input :type="showPassword ? 'text' : 'password'" @input="changePassword" @blur="showPasswordAuth = false" v-model="form.password" :placeholder="$t('qing-shu-ru-xin-mi-ma')">
        </div>
        <div class="adot" @click="changeShowPassword">
          <img :src="showPassword ? eyeUrl2 : eyeUrl" alt="" >
        </div>

        <div class="password-auth" v-show="showPasswordAuth ">
          <div class="auth-line flex-center-start" :class="passwordAuthList.indexOf(0) > -1 ? 'green' : ''"> 
            <img :src="passwordAuthList.indexOf(0) > -1 ? checkUrl2 : checkUrl" alt="">
            <span>{{ $t('register.passwordMinLength') }}</span>
          </div>
        </div>
      </div>
      


      <div class="form-label" v-show="step == 3">
       {{ $t('zai-ci-shu-ru-xin-mi-ma') }} </div>

      <div class="form-item flex-center" v-if="step == 3" >
        <div class="input"> 
          <input :type="showPassword2 ? 'text' : 'password'" @input="changeConfirmPassword" v-model="form.password2" :placeholder="$t('zai-ci-shu-ru-xin-mi-ma-0')">
        </div>
        <div class="adot" @click="changeshowPassword2">
          <img :src="showPassword2 ? eyeUrl2 : eyeUrl" alt="" >
        </div>
      </div>


      
    </div>

    <Button class="login-btn" @click="submit" :class="btnDisabled ? '' : 'disabled'"  v-if="step == 1">{{ $t('userAuth.btn1') }}</Button>
    <div class="btn-line" v-if="step > 1">
      <Button class="login-btn gray" @click="cancel" >{{ $t('register.cancel') }}</Button>
      <Button class="login-btn" @click="submit" :class="btnDisabled ? '' : 'disabled'">{{ $t('addAddress.btn2') }}</Button>
    </div>
  </div>
</template>
<script>
  import { Button, Popup, Icon, Picker } from 'vant'
  import { resetPassword, sendCode, checkEmailCode, sendSms, checkPhoneCode } from '@/api/login'
  import { setToken, setUser, setUserId } from '@/utils/auth'
  import { normalizePassword, isPasswordLongEnough, validatePasswordPair } from '@/utils/passwordRules'
  export default {
    components: {
      Button,
      Popup,
      Icon,
      Picker
    },
    data() {
      return {
        step: 1,
        form: {
          username: '',
          phone: '',
          password: '',
          password2: '',
          code: '',
          inviteCode: '',
          cardType: '',
          cardTypeName: '',
          cardNo: ''
        },
        inputActive: false,
        eyeUrl: require('../../assets/imgs/icon-eye.png'),
        eyeUrl2: require('../../assets/imgs/icon-eye2.png'),
        checkUrl: require('../../assets/imgs/icon-close.png'),
        checkUrl2: require('../../assets/imgs/icon-check.png'),
        downUrl: require('../../assets/imgs/icon-arrow-down2.png'),
        showPassword: false,
        showPassword2: false,
        activeIndex: 1,
        isDisabled: false,
        sendTime: '',
        checkRole: false,
        showInvite: true,
        showPasswordAuth: false,
        passwordAuthList: [],
        phonePre: '+86',
        tabIndex: 1,
        showPopup: false,
        countryList: [],
        keyword: '',
        linkList: [],
        showPicker: false,
      }
    },
    computed: {
      timeCount() {
        return this.sendTime + 's'
      },
      btnDisabled() {
        if (this.step == 1) {
          return this.form.username || this.form.phone
        } else if (this.step == 2) {
          return this.form.code
        } else if (this.step == 3) {
          return isPasswordLongEnough(this.form.password) && !!normalizePassword(this.form.password2)
        } else {
          return this.form.password && this.form.password2 
        }
      },
      countryListBak() {
        return this.$store.state.countryList
      }
    },
    mounted() {
      this.countryList = [].concat(this.countryListBak)
      this.linkList = this.countryList.filter(v => {
        return v.id != 'common'
      })
    },
    methods: {
      changeTab(index) {
        if (this.step == 1) {
          this.tabIndex = index
        } 
      },
      back() {
        this.$router.go(-1)
      },
      toLogin() {
        this.$router.push({ name: 'login', query: this.$route.query })
      },
      toSet() {
        if (!this.form.code ) {
          this.$toast.fail(this.$t('qing-shu-ru-yan-zheng-ma'))
          return
        }
        let form = new FormData()
        form.append('Code', this.form.code)
        form.append('Type', 2)
        if (this.tabIndex == 2) {
          form.append('Email', this.form.username)
          checkEmailCode(form).then(res => {
            if (res.code == 0) {
              this.step = 3
            } else {
              this.$toast.fail(res.msg)
            }
          })
        } else {
          form.append('Phone', this.phonePre + this.form.phone)
          checkPhoneCode(form).then(res => {
            if (res.code == 0) {
              this.step = 3
            } else {
              this.$toast.fail(res.msg)
            }
          })
        }
      },
      submit() {
        if (!this.btnDisabled) {
          return
        }

        if (this.step == 1) {
          this.step = 2
        } else if (this.step == 2) {
          this.toSet()
        } else if (this.step == 3) { // 重置密码
          const validation = validatePasswordPair(this.form.password, this.form.password2)
          this.form.password = validation.password
          this.form.password2 = validation.confirmPassword

          if (!validation.password) {
            this.$toast.fail(this.$t('resetPassword.labelPlaceholder2'))
            return
          }
          if (validation.isTooShort) {
            this.$toast.fail(this.$t('register.passwordMinLength'))
            return
          }
          if (!validation.confirmPassword) {
            this.$toast.fail(this.$t('zai-ci-shu-ru-xin-mi-ma-0'))
            return
          }
          if (validation.isMismatch) {
            this.$toast.fail(this.$t('register.passwordDiff'))
            return
          }

          let form = new FormData()
          if (this.tabIndex == 2) {
            form.append('Email', this.form.username)
          } else {
            form.append('Phone', this.phonePre + this.form.phone)
            form.append('CountryCode', this.phonePre)
          }
          form.append('Password', validation.password)
          form.append('Code', this.form.code)
          resetPassword(form).then(res => {
            if (res.code == 0) {
              this.$toast.success(this.$t('resetPassword.success'))
              this.$router.push({
                name: 'login'
              })
            } else {
              this.$toast.fail(res.msg)
            }
          })
        }
      },
      sendEmail() {
        if (!this.form.username) {
          this.$toast.fail(this.$t('qing-shu-ru-you-xiang-hao-ma-0'))
          return
        }
        let form = new FormData()
        form.append('Email', this.form.username)
        form.append('Type', 2)
        sendCode(form).then(res => {
          if (res.code == 0) {
            this.countDown(60)
            this.step = 2
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      sendPhoneSms() {
        if (!this.form.phone) {
         this.$toast.fail(this.$t('qing-shu-ru-shou-ji-hao-ma-0'))
          return
        }
        let form = new FormData()
        form.append('Phone', this.phonePre + this.form.phone)
        form.append('Type', 2)
        sendSms(form).then(res => {
          if (res.code == 0) {
            this.countDown(60)
            this.step = 2
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      countDown(time) {
        if (time > 0) {
          this.isDisabled = true
          time -= 1
          this.sendTime = time
          setTimeout(() => {
            this.countDown(time)
          }, 1000)
        } else {
          this.sendTime = ''
          this.isDisabled = false
        }
      },
      cancel() {
        this.$router.push({ name: 'login', query: this.$route.query })
      },
      checkCodeSize() {
        let code = this.form.code + ''
        if (code.length > 6) {
          code = code.substring(0, 6)
          this.form.code = parseInt(code)
        }
      },
      getCodeActive(i) {
        let code = this.form.code + ''
        if (!code) {
          return i == this.activeIndex ? 'active' : ''
        }
        return i == code.length + 1 ? 'active' : ''
      },
      inputCode() {
        this.activeIndex = 1
        this.$refs.codeInput.focus()
      },
      getCodeStr(i) {
        let code = this.form.code + ''
        if (!code) {
          return ''
        }
        let str = code.substring(i - 1, i)
        return str
      },
      resend() {
        if (this.isDisabled) {
          return
        } else {
          if (this.tabIndex == 1) {
            this.sendPhoneSms()
          } else {
            this.sendEmail()
          }
        }
      },
      changeRole() {
        this.checkRole = !this.checkRole
      },
      changeShowPassword() {
        this.showPassword = !this.showPassword
      },
      changeshowPassword2() {
        this.showPassword2 = !this.showPassword2
      },
      changeShowInvite() {
        this.showInvite = !this.showInvite
      },
      changePassword() {
        this.form.password = normalizePassword(this.form.password)
        this.showPasswordAuth = !!this.form.password
        let result = []

        if (isPasswordLongEnough(this.form.password)) {
          result.push(0)
        }

        this.passwordAuthList = result
      },
      changeConfirmPassword() {
        this.form.password2 = normalizePassword(this.form.password2)
      },
      changePre() {
        this.showPopup = true
      },
      chooseCountry(data) {
        this.phonePre = data.key
        this.showPopup = false
      },
      getCountryName(name) {
        if (!name) {
          return ''
        }
        let newName = ''
        newName = name.substring(0, name.indexOf('(') - 1)
        return newName
      },
      searchCountry() {
        if (this.keyword) {
          this.countryList = this.countryListBak.map(v => {
            let children = v.children.filter(val => {
              return val.title.toLowerCase().indexOf(this.keyword.toLowerCase()) > -1  && v.id != 'common'
            })
            if (children.length > 0) {
              return {
                children: children
              }
            } else {
              return {
                children: []
              }
            }
          })
        } else {
          this.countryList = [].concat(this.countryListBak)
        }
      },
      toFastPage(key) {
        let dom = document.getElementById(key.id)
        let parentDom = document.querySelector('.country-list')
        if (dom && parentDom) {
          let domTop = dom.offsetTop
          parentDom.scrollTo({
            top: domTop - 124
          })
        }
      },
      chooseType(item) {
        this.form.cardType = item.value
        this.form.cardTypeName = item.text
        this.showPicker = false
      },
      changeType() {
        this.showPicker = true
      },
    },
  }
</script>
